import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { PostIndustryDto } from '@/services/ws-post-crm/src/main/resources/rest-api';
import { getPostIndustries } from '@/services/ws-post-crm/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import type { Option } from 'src/types';
import { formatIndustryOptionLabel } from '../helpers';

type UseIndustriesPostCrmOptionsReturn = {
  options: Option<PostIndustryDto>[];
  pending: boolean;
};

export const useIndustriesPostCrmOptions = (): UseIndustriesPostCrmOptionsReturn => {
  const [, { language }] = useTranslation(['backend']);

  const { data$, pending$ } = useRequest({
    apiMethod: getPostIndustries,
    params: {},
  });

  const options = useSubscribe(
    data$,
    (response) =>
      response?.data.map((industry) => ({
        label: formatIndustryOptionLabel(industry, language),
        value: industry,
      })) ?? [],
    [language],
  );
  const pending = useSubscribe(pending$);

  return useMemo(() => ({ options, pending }), [options, pending]);
};
